import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import CardDetalhe from '../../../comum/components/CardDetalhe'
import moment from 'moment'
import { Baixar } from '../../../comum/components/Icones'

export default class DetalhesDirecionamento extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }


    render() {
            return (
                <Col className="container-card-detalhe">
                    <Row className="m-0 no-gutters">
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className="card-detalhe">
                                <div className="card-detalhe--conteudo">
                                    <Row className="justify-content-between">
                                        <Col>
                                            <h5>Arquivo anexo</h5>
                                            {this.props.row.NomeArquivo}
                                        </Col>
                                        {this.props.row.NomeArquivo
                                        ? <Col>
                                            <Baixar tamanho="2x" className="pr-0 icone-download" onClick={() => this.controller.downloadArquivoAnexo(this.props.row.DirecionamentoTeconId, this.props.row.NomeArquivo)} />
                                        </Col>
                                        : null}
                                    </Row>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                            <CardDetalhe
                                titulo="Criado por" 
                                desc={[this.props.row.NomeImport]}
                                titulo2="Data e hora" 
                                desc2={[ this.props.row.DtImport ? moment(this.props.row.DtImport).format("DD MMM, YYYY (HH:mm)") : "---" ]}
                            />
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                            <CardDetalhe
                                titulo="Inativado por" 
                                desc={[this.props.row.NomeCancel]}
                                titulo2="Data e hora"
                                desc2={[ this.props.row.DtCancel ? moment(this.props.row.DtCancel).format("DD MMM, YYYY (HH:mm)") : "---" ]}
                            />
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className="card-detalhe">
                                <div className="card-detalhe--conteudo">
                                    <Row>
                                        <Col>
                                            <h5>Containers</h5>
                                            {this.props.row.Container ? this.props.row.Container.replace(/,/g,' / ') : null}
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            )
        }
}



// WEBPACK FOOTER //
// ./src/modules/direcionamento/tecon/components/DetalhesDirecionamento.js